import React, { useEffect, useState } from "react";
import {  Container, Row, Col, Card, CardBody, Button, Spinner } from "reactstrap";
import InstitutionForm from './components/InstitutionForm'
import { getInstitution, postInstitution, resetPostInstitution, resetViewInstitution } from '../actions/institution.actions';
import { connect } from "react-redux";
import HorizontalForm from "../../Users/UserForm/components/UserForm";
import PageHeader from '../../../shared/components/PageHeader';
import { postUser } from "../../Users/actions/user.actions";
import FinishSetup from "./components/FinishSetup";


const InstitutionFormView = props => {
    const [moveToFinish, setMoveToFinish] = useState(false)
    const [adminEmailFromForm, setAdminEmail] = useState("")
    const [goToUserSetup, setGoToUserSetup] = useState(false)
    const [fepDomain, setFepDomain] = useState(null)
    const [userObj, setUserObj] = useState(null)


    const finishSetup = () => {
        setMoveToFinish(true);
    }
    const addUser = values => {
        let newValues = {...values, domainCode: fepDomain?.domainCode}
        setAdminEmail(values.email);
        setUserObj(values)
        props.dispatch(
          postUser(newValues, props.currentUser, null, null,finishSetup )
        );
      };
    const redirectToInstitutionsTable = () => props.history.push('/institution');
    const updateInstitution = () => {
        let valueObj = {};
        if(props.postInstitution.response) {
            let emailToUse;
            const { id, adminEmail, fepCode, domainCode, name } = props.postInstitution?.response;
            if(adminEmail && adminEmail.length) {
                emailToUse = adminEmail;
            } else {
                emailToUse = adminEmailFromForm;
            }
            valueObj = { name, id, fepCode, domainCode, adminEmail: emailToUse, stat: 'edit' };
        }
        try {
            props.dispatch(postInstitution(valueObj, redirectToInstitutionsTable));
        } catch (error) {
            console.error(error)
        }
    };

    const checkIfAdminUserExists = () => {
        const emailLength = props.postInstitution.response?.adminEmail?.length;
        if(emailLength > 0 || isAdminPresent) {
            return props.history.push('/institution')
        } else {
            return setGoToUserSetup(true)
        }
    }
    const createInstitution = (value) => {
        let valueObj;
        const expiryYear = value.expiryDate && (value.expiryDate.getFullYear()).toString();
        const expiryMonth = value.expiryDate && (value.expiryDate.getMonth() + 1).toString();
        if(Object.keys(value).length > 0) {
            valueObj = {
                ...value,
                expiryDate: value.expiryDate ? `${expiryYear.substring(2,4)}${expiryMonth.length > 1 ? expiryMonth : ('0' + expiryMonth)}` : null,
                fepCode: value.fepCode?.code, domainCode: value.fepCode?.domainCode
            }
            if(props.match.params.id) {
                valueObj.id = props.match.params.id;
            }
            try {
                props.dispatch(postInstitution(valueObj, checkIfAdminUserExists));
            } catch (error) {
                console.error(error)
            }
        }
    };
    const createFormData = data => {
        let institutionData;
        if(data) {
            let fepCode;
            if(props.fep.fep_response){
               const fepData = props.fep.fep_response.filter(x => x.code === data.fepCode)
                fepCode= fepData[0];
            }
            institutionData = {
                name: data.name,
                subscriberId: data.subscriberId,
                clientId: data.clientId,
                fepCode
            }
        }
        return institutionData
    };
    useEffect(() => {
        if (props.match.params.id) {
          props.dispatch(getInstitution(props.match.params.id));
        }
        return () => {
          props.dispatch(resetPostInstitution());
          props.dispatch(resetViewInstitution());
        };
    }, [props.dispatch, props.match.params.id]);
    
    const isAdminEmailPresentInInstitutionToEdit = () => {
        const idFromBrowser = props.match.params?.id;
        const idFromInstitutionInView = props.viewInstitution.response?.id;
        if(idFromBrowser && idFromInstitutionInView && idFromBrowser == idFromInstitutionInView){
            if(props.viewInstitution.response?.adminEmail !== null){
                return true;
            } else {
                return false;
            }
        }
        return false
    };
    const isAdminPresent = isAdminEmailPresentInInstitutionToEdit();
    return (
        <Container>
            
            {moveToFinish ?
                <>
                    <PageHeader
                        header="Final step"
                        subheader="Finish set up"
                    />
                    <Row>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="wizard">
                                        <div className="wizard__steps">
                                            <div
                                                className="wizard__step"
                                            >
                                                <p>Institution Details</p>
                                            </div>
                                            <div
                                                className="wizard__step" 
                                            >
                                                <p>Create Admin User</p>
                                            </div>
                                            <div
                                                className="wizard__step wizard__step--active"
                                            >
                                                <p>Finish Setup</p>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <FinishSetup 
                                        loading={props.postInstitution.loading}
                                        institutionObj={props.postInstitution.response}
                                        userObj={userObj}
                                        updateInstitution={updateInstitution}
                                    />
                                    {/* <div style={{display: 'flex', justifyContent: 'center'}}>
                                        <div>
                                            {`Update Institution - ${props.postInstitution.response.name} with User - ${adminEmailFromForm}`}
                                        </div>
                                        <br />
                                        <Button color="primary" id="submit-btn" type="submit" onClick={updateInstitution} style={{margin: '0 auto'}}>
                                            {props.postInstitution && props.postInstitution.loading ? (
                                            <span>
                                            <Spinner size="sm" color="default" />{" "}
                                            </span>
                                        ) : ''}
                                            Update Institution
                                        </Button> 
                                    </div> */}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </> :
                <>
                    {
                        goToUserSetup && !props.postInstitution.response?.adminEmail ?                    
                        <>
                            <PageHeader
                                header={`Create admin user for Institution - ${props.postInstitution.response?.name}`}
                                subheader="Create new user"
                            />
                            <Row>
                                <HorizontalForm 
                                    onSubmit={addUser}
                                    external={true}
                                    extFunc={setAdminEmail}
                                    extDomain={fepDomain}
                                />
                            </Row>
                        </> :
                        <>
                        <PageHeader
                            header={`${props.match.params.id ? "Edit" : "Add"} Institution`}
                            subheader={`${props.match.params.id ? "Update institution details" : "Add new institution"}`}
                        />
                        <Row>
                            <InstitutionForm
                                institutionId={props.match.params.id}
                                onSubmit={createInstitution}
                                postInstitution={props.postInstitution}
                                initialValues={createFormData(props.currentInstitution.response)}
                                institution={props.currentInstitution}
                                setFepDomain={setFepDomain}
                                isAdminPresent={isAdminPresent !== null ? isAdminPresent : false}
                            /> 
                        </Row>
                    </> 
                    }
                </>
            }
        </Container>
    )

}

export default connect((state) => ({
    postInstitution: state.postInstitution,
    viewInstitution: state.viewInstitution,
    fep: state.getInstitution,
    currentInstitution: state.viewInstitution,
    currentUser: state.currentUser
}))(InstitutionFormView);

